
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  TeamLegalEntitiesResource,
} from '../models';
import {
    TeamLegalEntitiesResourceFromJSON,
    TeamLegalEntitiesResourceToJSON,
} from '../models';

export interface FindTeamLegalEntitySummariesRequest {
    legalEntityIds: Array<string>;
}

/**
 * 
 */
export class TeamLegalEntitySummariesApi extends runtime.BaseAPI {

    /**
     * Find legal entity summaries by id, including their additional billing profiles
          */
    async findTeamLegalEntitySummariesRaw(requestParameters: FindTeamLegalEntitySummariesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<TeamLegalEntitiesResource>> {
        if (requestParameters['legalEntityIds'] == null) {
            throw new runtime.RequiredError(
                'legalEntityIds',
                'Required parameter "legalEntityIds" was null or undefined when calling findTeamLegalEntitySummaries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['legalEntityIds'] != null) {
            queryParameters['legalEntityIds'] = requestParameters['legalEntityIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<TeamLegalEntitiesResource>({
            path: `/compliance/api/legal-entities/team-summaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=TeamLegalEntitiesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find legal entity summaries by id, including their additional billing profiles
          */
    async findTeamLegalEntitySummaries(requestParameters: FindTeamLegalEntitySummariesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<TeamLegalEntitiesResource> {
        const response = await this.findTeamLegalEntitySummariesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
